var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy244(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg5673"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 49.6,
    cy: 49.6,
    r: 32.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.7,
    y: 62.9,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 -14.7619 113.9745)",
    fill: "#FFAF00",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 13.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.1,
    y: 40.6,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 48.4773 -32.9192)",
    fill: "#FFAF00",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 13.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.3,
    y: 40.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -19.4186 37.2347)",
    fill: "#FFAF00",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 13.8,
    height: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy244);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-244.38fd9aacff71cf37be3f5a510836cae3.svg";
export { ForwardRef as ReactComponent };